module.exports = __webpack_public_path__ + "static/media/takeoff.3f4020c9.svg";